import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import { selectCurrency, selectId, selectToken } from "../../../features/user/userSlice";
import { API_URL } from "../../../const/api";
import { formatNumber } from "../../../utils/tools";
import pay4funpasarela from '../../../assets/images/pay4funpasarela.png';
import Rpay4fun from '../../../assets/images/RETIPAY4FUN.svg';

const FormPay4Fun = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const [bancos, setBancos] = useState([]);
  const [pix, setPix] = useState(false);
  //const [minMonto, setMinMonto] = useState(0);

  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const id_uo = useSelector(selectId);

  const handleChangePix = (e) => {
    handleChange(e);
    if (e.target.value === "DadosBancarios") setPix("bank");
    else if (e.target.value === "Telefone") setPix("tlf");
    else setPix(false);
  };

  useEffect(() => {
    const getBanks = async () => {
      const res = await axios.post(API_URL + "getBankList", {});
      setBancos(res.data.response);

      /*const limitP4f = await axios.post(API_URL+'getLimitP4F', {id_uo, token, moneda});
      setMinMonto(limitP4f.data.response);*/

    };
    getBanks();
  }, []);

  const formatPhone = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    e.target.value = value;
    return e;
  };

  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form>
      <InputContainer>
        <label>{t('join-us.input-fullname')}:</label>
        <input
          type="text"
          placeholder={t('join-us.input-fullname')}
          name="nombre"
          value={form.nombre}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
        <label>CPF:</label>
        <input
          type="text"
          placeholder="CPF"
          name="cedula"
          value={form.cedula}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
        <label>EMAIL:</label>
        <input
          type="text"
          placeholder="EMAIL"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
        <label>PIX</label>
        <select
          value={form.pixKeyType}
          onChange={handleChangePix}
          name="pixKeyType"
        >
          <option disabled value="">
            SELECCIONE EL PIX
          </option>
          <option value="CPF">CPF</option>
          <option value="Email">EMAIL</option>
          <option value="Telefone">TELEFONO</option>
          <option value="DadosBancarios">DATOS BANCARIOS</option>
        </select>
      </InputContainer>

      {pix === "bank" && (
        <>
          <InputContainer>
            <label>{t("deposit.lbl-bank")}</label>
            <select
              value={form.nombreBanco}
              onChange={handleChange}
              name="nombreBanco"
            >
              <option disabled value="">
                {t("deposit.input-bank")}
              </option>
              {bancos.map((item) => (
                <option
                  key={item.bankCode}
                  value={`${item.bankName}_${item.bankCode}`}
                >
                  {item.bankName}
                </option>
              ))}
            </select>
          </InputContainer>

          <InputContainer>
            <label>NÚMERO CUENTA:</label>
            <input
              type="text"
              placeholder="NUMERO CUENTA"
              name="numeroCuenta"
              value={form.numeroCuenta}
              onChange={handleChange}
            />
          </InputContainer>

          <InputContainer>
            <label>SUCURSAL BANCO</label>
            <input
              type="text"
              placeholder="SUCURSAL BANCO"
              name='sucursalBanco'
              value={form.sucursalBanco}
              onChange={handleChange}
              maxLength={4}
            />
          </InputContainer>

          <InputContainer>
            <label>TIPO DE CUENTA:</label>
            <select
              value={form.tipoCuenta}
              onChange={handleChange}
              name="tipoCuenta"
            >
              <option disabled value="">
                SELECCIONE EL TIPO DE CUENTA
              </option>
              <option value="SAVING">AHORRO</option>
              <option value="PERSONAL">PERSONAL</option>
            </select>
          </InputContainer>
        </>
      )}

      {pix === "tlf" && (
        <>
          <InputContainer>
            <label>CÓDIGO DE ÁREA:</label>
            <input
              type="text"
              placeholder="CÓDIGO DE ÁREA"
              name="codigoArea"
              value={form.codigoArea}
              onChange={(e) => handleChange(formatPhone(e))}
            />
          </InputContainer>

          <InputContainer>
            <label>TELÉFONO:</label>
            <input
              type="text"
              placeholder="TELÉFONO"
              name="telefono"
              value={form.telefono}
              onChange={(e) => handleChange(formatPhone(e))}
            />
          </InputContainer>
        </>
      )}

      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto2"
          value={form.monto2}
          onChange={(e) => handleMonto(e)}
        />

        {monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
        {monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
      <img src={Rpay4fun} alt='Pay4Fun' className={'pay4fun3'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={pay4funpasarela} alt='Pasarelas Pay4FUn' className={'pay4fun4'} style={{width:'120%', marginTop: '-5%', marginLeft: '-10%'}}/>
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button 
          primary={true}
          disabled={loading || monto < 50 || monto > 5000}
          onClick={solicitarRetiro}
        >
          {loading ? "CARGANDO..." : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormPay4Fun;
